module.exports = __webpack_public_path__ + "static/media/trend-icon-up.19f20a50.svg";